import React from 'react';
import Helmet from 'react-helmet';
import {withPrefix} from 'gatsby';

import Header from './header';
import Footer from './footer';
import './layout.css';
import HeroSection from './hero-section';

const Layout = ({
  children,
  isFrontPage,
  pageTitle,
  description,
  slogan,
  siteTitle,
  siteUrl,
  siteImage,
  siteFavicon
}) => {
  return (
    <div
      aria-describedby="pageTitle"
      className="js-page-focus"
      role="region"
      tabIndex="-1"
    >
      <Helmet
        htmlAttributes={{lang: 'en'}}
        title={pageTitle}
        meta={[
          {name: 'description', content: description},
          {name: 'twitter:card', content: 'summary_large_image'},
          {property: 'og:title', content: pageTitle},
          {property: 'og:type', content: 'website'},
          {property: 'og:image', content: `${siteUrl}${siteImage}`},
          {property: 'og:description', content: description},
        ]}
        link={[{rel: 'shortcut icon', type: 'image/png', href: `${siteUrl}${siteFavicon}`}]}
        script={[
          {src: withPrefix('/scripts/trekkie.js'), type: 'text/javascript'},
        ]}
      />
      <Header siteTitle={siteTitle} />
      <div id="PageContainer">
        <main role="main" id="Main">
          <HeroSection
            isFrontPage={isFrontPage}
            siteTitle={siteTitle}
            siteSlogan={slogan}
          />
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
